import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a25558f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduction-event" }
const _hoisted_2 = { class: "details" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "about-event" }
const _hoisted_5 = {
  key: 0,
  class: "menu-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Ementas da graduação:", -1))
const _hoisted_7 = { class: "menus" }
const _hoisted_8 = { class: "divisor-align" }
const _hoisted_9 = { class: "divisor-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line" }, null, -1))
const _hoisted_11 = { class: "buttons-align" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "attendance-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrainingTableOption = _resolveComponent("TrainingTableOption")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.type === _ctx.GRADUATION ? "Graduação:" : "Treinamento:") + " " + _toDisplayString(_ctx.data.name), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data.date || _ctx.hasMenu)
        ? (_openBlock(), _createBlock(_component_TrainingTableOption, {
            key: 0,
            icon: "calendar",
            label: "Data de realização",
            black: "",
            response: 
        _ctx.data.date.length
          ? _ctx.getLocalFormatDate(_ctx.data.date)
          : _ctx.formatMenusDates(_ctx.data.menus)
      
          }, null, 8, ["response"]))
        : _createCommentVNode("", true),
      (_ctx.data.schedule || _ctx.hasMenu)
        ? (_openBlock(), _createBlock(_component_TrainingTableOption, {
            key: 1,
            icon: "clock",
            label: "Horarios",
            black: "",
            response: 
        _ctx.data.schedule.length ? _ctx.data.schedule : _ctx.formatMenusSchedule(_ctx.data.menus)
      
          }, null, 8, ["response"]))
        : _createCommentVNode("", true),
      (_ctx.data.duration)
        ? (_openBlock(), _createBlock(_component_TrainingTableOption, {
            key: 2,
            icon: "clock",
            label: "Duração",
            black: "",
            response: _ctx.formattedDuration(_ctx.data.duration)
          }, null, 8, ["response"]))
        : _createCommentVNode("", true),
      (_ctx.data.location)
        ? (_openBlock(), _createBlock(_component_TrainingTableOption, {
            key: 3,
            icon: "location",
            label: "Local",
            black: "",
            response: _ctx.data.location
          }, null, 8, ["response"]))
        : _createCommentVNode("", true),
      (_ctx.data.maxCapacity)
        ? (_openBlock(), _createBlock(_component_TrainingTableOption, {
            key: 4,
            icon: "people",
            label: "Capacidade",
            black: "",
            response: _ctx.data.usersCount + '/' + _ctx.data.maxCapacity
          }, null, 8, ["response"]))
        : _createCommentVNode("", true),
      (_ctx.data.usersCount)
        ? (_openBlock(), _createBlock(_component_TrainingTableOption, {
            key: 5,
            icon: "people",
            label: "Inscritos",
            black: "",
            response: _ctx.data.usersCount
          }, null, 8, ["response"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_3, " Sobre " + _toDisplayString(_ctx.type === _ctx.GRADUATION ? "a graduação:" : "o treinamento:"), 1),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data.description), 1),
    (_ctx.data.menus[0].id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.menus, (menu, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatMenus(
                index,
                menu.startDate,
                menu.duration,
                menu.startHour,
                menu.endHour
              )), 1),
                  _hoisted_10
                ]),
                _createVNode(_component_TUIViewer, {
                  "model-value": menu.descriptionMarkdown,
                  class: "markdown-events"
                }, null, 8, ["model-value"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.type == _ctx.EVENT && _ctx.data.isActive && !_ctx.data.user.attendanceAt)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.unEnrollUser && _ctx.unEnrollUser(...args)), ["prevent"])),
            class: "action-button"
          }, " Cancelar inscrição "))
        : _createCommentVNode("", true),
      (_ctx.data.user?.certificateGenerated)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "action-button",
            href: _ctx.data.user.certificateGenerated,
            target: "_blank"
          }, " Visualizar certificado ", 8, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data.user.attendanceAt)
      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Presença marcada em " + _toDisplayString(_ctx.formattedDate(_ctx.data.user.attendanceAt)), 1))
      : _createCommentVNode("", true)
  ], 64))
}